import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Select,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";

const AddEditSubject = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    nameAr: "",
    nameEn: "",
    image: "",
    isActive: true,
    type: "",
    logo: "",
  });
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameEnError("");
  };
  const [nameEnError, setNameEnError] = useState("");

  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameArError("");
  };
  const [nameArError, setNameArError] = useState("");

  const handleSelectChangeType = (newValue) => {
    setItem({ ...item, type: newValue });
    setTypeError("");
  };
  const [typeError, setTypeError] = useState("");

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts png and jpegs (Required size: 720x1080 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };

  const [filesLogo, setFilesLogo] = useState([]);

  const handleDropZoneDropLogo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesLogo((filesLogo) => [...filesLogo, ...acceptedFiles]),
    []
  );
  const fileUploadLogo = !filesLogo.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs and jpegs (Required size: 300x300 pixels)"}
    />
  );
  const uploadedFilesLogo = filesLogo.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesLogo[filesLogo.length - 1].type)
              ? window.URL.createObjectURL(filesLogo[filesLogo.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesLogo[filesLogo.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesLogo[filesLogo.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );

  const sendImageLogo = (filesLogo) => {
    setItem({
      ...item,
      logo:
        validImageTypes.indexOf(filesLogo[filesLogo.length - 1].type) > 0
          ? window.URL.createObjectURL(filesLogo[filesLogo.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/subjects/${id}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            type:
              result?.data?.data?.type && result?.data?.data?.type?.id !== null
                ? String(result.data.data.type?.id)
                : "",
            nameEn:
              result?.data?.data?.name && result?.data?.data?.name?.en
                ? result.data.data.name.en
                : "",
            nameAr:
              result?.data?.data?.name && result?.data?.data?.name?.ar
                ? result.data.data.name.ar
                : "",
            image: result?.data?.data?.image ? result.data.data.image : "",
            logo: result?.data?.data?.logo ? result.data.data.logo : "",
            isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    setIsSaving(true);
    axios
      .delete(`/subjects/${id}`)
      .then((result) => {
        navigate("/admin/subjects");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Subject`}
      backAction={{ onAction: () => navigate("/admin/subjects") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <Select
            label="Type"
            options={[
              { label: "School", value: "1" },
              { label: "University", value: "2" },
            ]}
            onChange={handleSelectChangeType}
            value={item.type}
            error={typeError}
            placeholder="Please select"
            requiredIndicator
          />
          <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Name En"
              requiredIndicator
              error={nameEnError}
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Name Ar"
              align="right"
              requiredIndicator
              error={nameArError}
            />
          </FormLayout.Group>

          {/* <Text>
            Image <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".jpeg,.png,.jpg,.svg"
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} /> */}
          <Text>Logo</Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.logo ? item.logo : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpg,.jpeg"
                onDrop={handleDropZoneDropLogo}
                allowMultiple={false}
                onDropAccepted={sendImageLogo}
              >
                {uploadedFilesLogo}
                {fileUploadLogo}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />
      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/subjects/${id}`)
                  .then((result) => {
                    navigate("/admin/subjects");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (
      !item.nameEn ||
      !item.nameAr ||
      (props?.type === "add" && !filesLogo?.length) ||
      item.type === ""
    ) {
      !item.nameEn && setNameEnError("This field is required");
      !item.nameAr && setNameArError("This field is required");
      props?.type === "add" &&
        !filesLogo?.length &&
        setImageError("Please upload a logo");
      item.type === "" && setTypeError("Please enter a type");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("type", item.type);
      item.nameEn && form_data.append("name[en]", item.nameEn);
      item.nameAr && form_data.append("name[ar]", item.nameAr);
      // files?.length && form_data.append("image", files[0]);
      filesLogo?.length && form_data.append("logo", filesLogo[0]);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props?.type === "edit" && form_data.append("_method", "PATCH");
      props.type === "add"
        ? axios
            .post(`/subjects`, form_data)
            .then((result) => {
              navigate("/admin/subjects");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/subjects/${id}`, form_data)
            .then((result) => {
              navigate("/admin/subjects");
              // toggleActive();
              // setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditSubject;
